"use client";
import { InputComponentType, registerInputComponent } from "@eavfw/quickform-core";
import { ProductCollectionInputSchema } from "./ProductCollectionInputSchema";
import { ButtonsInput, ButtonsProperties } from "../../buttons-input/ButtonsInput";
import { DropdownInput } from "../../dropdown-input/DropdownInput";
import { ImageGrid } from "../../image-grid/ImageGrid";

//The options part is inserted by the backend upon save from the product id
export type ProductCollectionInputProps = {
    inputType: "product-collection-input";
    products: Array<string>;   
    useImages: boolean;
    useDropdown: boolean;
    options: {
        [key: string]: {
            key: string;
            label: string;
            imageUrl: string;
            imageHash: string;
        }
    };
    imagesPerRowControl?: {
        customImagesPerRow?: boolean;
        imagesPerRowDesktop?: number;
        imagesPerRowTablet?: number;
        imagesPerRowPhone?: number;
    };
} & Omit< ButtonsProperties, "inputType" >;


export const ProductCollectionInput: InputComponentType<ProductCollectionInputProps> = ({ products, inputType,  ...props }) => {
    //CONVERT product to options
    const buttonProps = props as Omit<typeof props, "inputType">;
    console.log("ProductInput", [props]);
    const useImages = Object.values(props.options).some(x => x.imageUrl);

    const {
        customImagesPerRow = false,
        imagesPerRowDesktop = 4,
        imagesPerRowTablet = 4,
        imagesPerRowPhone = 2
    } = props.imagesPerRowControl || {};

    if (props.useDropdown) {//@ts-ignore
        return <DropdownInput {...buttonProps} inputType="dropdown" />
    }

    if (useImages) { // @ts-ignore
        return <ImageGrid
            {...buttonProps}
            inputType="image-grid"
            customImagesPerRow={customImagesPerRow}
            imagesPerRowDesktop={imagesPerRowDesktop}
            imagesPerRowTablet={imagesPerRowTablet}
            imagesPerRowPhone={imagesPerRowPhone} />
    }

    return (//@ts-ignore
        <ButtonsInput  {...buttonProps} inputType="buttons" />
    )
}

ProductCollectionInput.inputSchema = ProductCollectionInputSchema;
registerInputComponent("product-collection-input", ProductCollectionInput);